<template>
    <main-content>
        <transactions-report-filter
            :action="filterAction"
            :exportExcel="exportToExcel"
        >
        </transactions-report-filter>
        <div>
            <kt-row>
                <kt-col lg="6" md="6" xs="12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body" style="color: black; background-color: #fff">
                            <h6>{{$t('label.last_updated')}}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin" dir="ltr">
                                    {{my_statements.last_updated }}
                                </h4>
                            </div>
                            <div class="line-divider mt-4 mb-3"></div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6 border-right">
                                    <div class="mb-3" style="font-size: 0.82rem">
                                        {{$t('label.statements_from')}}
                                    </div>
                                    <div class="text-center">
                                        <h4 class="fix-margin" dir="ltr">
                                            {{my_statements.from_date}}

                                        </h4>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="mb-3" style="font-size: 0.82rem">
                                        {{$t('label.statements_to')}}
                                    </div>
                                    <div class="text-center">
                                        <h4 class="fix-margin" dir="ltr">
                                            {{my_statements.to_date}}
                                        </h4>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="position-absolute" style="left:20px;top:0px;cursor: pointer;">
                        <button class="no-border" @click="updateReport($event, query)" >
                            <i class="fa flaticon-refresh" aria-hidden="true"
                               style="font-size: 1.6em; color: #0f9af0"
                               :title="$t('label.reportUpdate')"
                            >
                            </i>
                        </button>
                    </div>

                </kt-col>
                <kt-col lg="6" md="6" xs="12">
                    <div class="kt-portlet">
                        <div class="kt-portlet__body" style="color: black; background-color: #fff">
                            <h6>{{$t('label.terminal_title')}}</h6>
                            <div class="text-center">
                                <h4 class="fix-margin">
                                    {{my_statements.persian_name }}
                                </h4>
                            </div>
                            <div class="line-divider mt-4 mb-3"></div>
                            <div class="row">
                                <div class="col-md-6 col-lg-6 col-sm-6 border-right">
                                    <div class="mb-3" style="font-size: 0.82rem">
                                        {{$t('label.total_transactions')}}
                                    </div>
                                    <div class="text-center">
                                        <h4 class="fix-margin">
                                            {{ my_statements.total_statements }}
                                            <span style="font-size: 1.5rem">
                                                {{' ' + $t('currency.rial')}}
                                            </span>

                                        </h4>
                                    </div>
                                </div>
                                <div class="col-md-6 col-lg-6 col-sm-6">
                                    <div class="mb-3" style="font-size: 0.82rem">
                                        {{$t('label.succeeded_transactions_number')}}
                                    </div>
                                    <div class="text-center">
                                        <h4 class="fix-margin">
                                            {{my_statements.total_success_transactions}}
                                        </h4>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </kt-col>
            </kt-row>

        </div>
        <div>
            <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
        </div>
    </main-content>
</template>

<script>
    import $ from 'jquery'
    import { ApiUrl } from '@/common/api.service'
    import columns from './datatable/statements-report-columns'
    import statementsReportFilter from './components/statements-report-filter'
    import { AuthorizationHeader } from '@/common/jwt.service'
    import mainContent from '@/components/main-content'
    import {mapGetters} from "vuex";
    import store from '@/store'
    import axios from "axios";
    import toastr from "toastr";
    import { KTApp } from '@/plugins/core/app'
    import { i18n } from '@/plugins/i18n'

    export default {
        name: "statements-user",
        components: {
            mainContent,
            'transactions-report-filter': statementsReportFilter
        },
        data() {
            return {
                headerAction: {
                    left: '10px',
                    top: '10px',
                    position: 'absolute'
                },
                query: {
                    'shop_type': 'PF',
                    psp: this.$route.query.psp
                },
                gateway_id: this.$route.params.hashid,
            }
        },
        computed: {
            toastr() {
                toastr.options = {
                    closeButton: true,
                    positionClass: "toast-bottom-center",
                    preventDuplicates: false,
                    rtl: false
                }
                return toastr
            },
            datatableProps() {
              const self = this
                return {
                    id: "datatable",
                    data: {
                        type: 'remote',
                        source: {
                            read: {
                                url: ApiUrl.path(`gateway/gateway-statements/${this.gateway_id}`),
                                method: 'GET',
                                headers: AuthorizationHeader,
                                map: (res) => {
                                    return res.data.data.data
                                },
                                params: {
                                    query: this.query,
                                },
                                success: function (res) {
                                  let params = {
                                    hashid: res.data.data.shop_id,
                                    query: {
                                      psp:self.$route.query.psp
                                    }
                                  }
                                    store.dispatch('gateway/fetchReportStatisticsStatements', params)
                                },
                            }
                        },
                        pageSize: 15,
                        serverPaging: true,
                        serverFiltering: true,
                        serverSorting: true,
                    },
                    pagination: false,
                    sortable: true,
                    columns: columns,

                }
            },
            ...mapGetters('gateway', [
                'status', 'my_statements'
            ]),
        },
        methods: {
            updateReport(e, query) {
                query.reportUpdate = true
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
            },
            exportToExcel(e, query){
                let btn = $('#export_psp_transations_btn')
                KTApp.progress(btn)

                this.query = query
                axios({
                    url: ApiUrl.path(`gateway/export-statements-report/${this.gateway_id}`),
                    method: 'GET',
                    params: this.query,
                    responseType: 'blob',
                }).then((response) => {
                    KTApp.unprogress(btn);
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'statements.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                }).catch(({response}) => {
                    this.toastr.error(i18n.t('message.an_error_accord'))
                    KTApp.unprogress(btn)
                })
            },
            filterAction(e, query) {
                query.reportUpdate = false
                if (query.from_date) {
                    var from_date = new Date(query.from_date);
                }
                if (query.to_date) {
                    var to_date = new Date(query.to_date);
                }
                if (to_date && from_date && from_date > to_date) {
                    this.toastr.error(i18n.t('message.error_my_statements'))
                    return;
                }
                this.query = query
                if (this.$refs.datatable.KTDatatable) {
                    this.$refs.datatable.reload()
                }
                this.fetchReportStatisticsStatements(this.gateway_id)
            },
            fetchReportStatisticsStatements(hashid) {
              let params = {
                hashid,
                query: {
                  psp: this.$route.query.psp
                }
              }
                store.dispatch('gateway/fetchReportStatisticsStatements', params)
            }
        },
    }
</script>

<style>
</style>